import React, { useMemo, useCallback, memo } from "react";
import { Navigate, Link } from "react-router-dom";


/**
 * Helper function to get initials from name
 */
const getInitials = (name) => {
  const names = name.split(" ");
  return names
    .map((n) => (n && n !== "null" ? n.charAt(0).toUpperCase() : ""))
    .join("");
};

/**
 * Header component - Converted from class to functional component for better performance
 */
const Header = memo(({ toggleSidebar, closeSidebar }) => {
  // Memoize user data from localStorage
  const userData = useMemo(() => {
    const udata = localStorage.getItem("user");
    if (!udata) return null;
    try {
      return JSON.parse(udata);
    } catch {
      return null;
    }
  }, []);

  const user = userData?.user;
  const isLoggedIn = !!userData;

  // Memoize initials calculation
  const initials = useMemo(() => {
    if (!user) return "RE";
    return getInitials(`${user.first_name || ''} ${user.last_name || ''}`);
  }, [user]);

  // Memoize toggle handler
  const handleToggle = useCallback(() => {
    toggleSidebar?.();
  }, [toggleSidebar]);

  // Redirect if not logged in
  if (!isLoggedIn) {
    return <Navigate to="/sign-in" />;
  }

  return (
    <nav className="navbar navbar-expand bg-light bg-white sticky-top px-lg-5 px-2 py-0">
      {/* ====== Hamburger Button to Toggle Sidebar ====== */}
      <button
        className="sidebar-toggler flex-shrink-0 bg-transparent border-0"
        onClick={handleToggle}
      >
        <i className="fa fa-bars" />
      </button>

      {/* Customer Business Name placeholder */}
      <form className="d-none d-md-flex align-items-center ms-4">
        <h3>{/* Customer Business Name */}</h3>
      </form>

      <div className="navbar-nav align-items-center ms-auto">
        {/* Cash/Earnings Dropdown */}
        <div className="money-container nav-item dropdown mx-lg-5 mx-md-2 mx-sm-2">
          <a target="_blank" href="https://eventtrackit.com/learn.html" className="d-none d-lg-inline-flex me-lg-1">Video Tutorials</a>
        </div>



        {/* User Dropdown */}
        <div className="nav-item dropdown" id="top-user-nav">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <span
              className="d-inline-flex p-lg-3 p-md-2 p-2 rounded-circle lead"
              id="user-av"
            >
              <strong>{initials}</strong>
            </span>
          </Link>

          <div
            className="dropdown-menu dropdown-menu-end bg-white shadow-sm border-0 py-2 rounded-0 rounded-bottom"
            id="cm-dropdown"
          >
            <Link to="#" className="dropdown-item py-2">
              <div className="d-flex align-items-center">
                <div
                  className="me-2 p-3 rounded-circle text-black"
                  id="user-dp"
                >
                  {initials}
                </div>
                <span>
                  <div>
                    <strong>
                      {user?.first_name} {user?.last_name}
                    </strong>
                  </div>
                  <div className="mt-2">Company Name</div>
                </span>
              </div>
            </Link>
            <hr className="my-1 py-0" />
            <Link
              to="/company-setting/my-account"
              className="dropdown-item py-2"
            >
              <i className="fa-solid fa-user me-2" />
              My Account
            </Link>
            <Link
              to="/company-setting/my-company"
              className="dropdown-item py-2"
            >
              <i className="fa-solid fa-hotel me-2" />
              Company Settings
            </Link>
            <div className="dropdown-item py-2">
              <div className="d-flex align-items-center justify-content-between mt-3">
                <Link to="/logout" className="text-dark">
                  Logout
                </Link>
                <a href="https://eventtrackit.com/help-center.html" className="text-dark"> Help Center </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
});

Header.displayName = 'Header';

export default Header;
